import { TranslationsToolbarController } from "./translations-toolbar.controller";

angular
    .module("thor.shared.translations.translations-toolbar.component", [])
    .component("translationsToolbar", {
        bindings: {
            getTranslationStatus: "&",
            setTranslationStatus: "&",
            fetchAll: "&",
            initiatePublish: "&",
            isPast: "<",
            isPublishDisabled: "<",
            resourceId: "<",
            translationsStatus: "<",
            selectedTargetLanguage: "=",
            sourceLang: "<",
            saleId: "<"
        },
        controller: TranslationsToolbarController,
        template: require("../../shared/translations/translations-toolbar.html")
    });
